import { cached } from '@glimmer/tracking';
import uniq from 'lodash-es/uniq';
import compact from 'lodash-es/compact';
import {
  FilterId,
  FilterOptionsType,
  MultiSelectListFilter,
} from 'uplisting-frontend/utils/filters/abstract';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export class CityFilter extends MultiSelectListFilter {
  id = FilterId.city;
  optionsType = FilterOptionsType.store;
  modelName = 'property';

  @cached
  override get options(): string[] {
    const properties = super.models as unknown as ModelRegistry['property'][];

    if (!properties || properties.length === 0) {
      return [];
    }

    const addresses = properties
      .map((property) => property.address)
      .filter((address) => address?.city);

    const cities = compact(uniq(addresses.map((address) => address.city)));
    return cities.sort();
  }
}
